// extracted by mini-css-extract-plugin
export var bounce = "_jg-1";
export var generatingText = "_jg-6";
export var lightning = "_jg-4";
export var popup = "_jg-5";
export var progressBar = "_jg-7";
export var progressFill = "_jg-8";
export var progressShimmer = "_jg-9";
export var progressText = "_jg-a";
export var shimmer = "_jg-3";
export var uploadIcon = "_jg-0";
export var uploadingText = "_jg-2";